import React from 'react';
import '../template-file-css/document-file-template.css';


export const RPBS_ClientSignatureConfirmationSheet = ({
    itemsRef,
    showErrorFor,
}) => {

    return (
        <form id='RPBS_ClientSignatureConfirmationSheet' className='file-pdf-document'>
            <div className='file-template'>
            <h3>Client Signature Confirmation Sheet</h3>
<table>
    <tr>
        <td className='w-375'><span className='eleHeader'>Client Name:</span></td>
        <td className='w-375'><span className='eleHeader'>CID:</span></td>

    </tr>
    <tr>
        <td className='w-375'>
            <input type='text' id='txtClientName' name='txtClientName' className='add-only'/></td>
        <td className='w-375'>
            <input type='text' id='txtDateAssessment' name='txtDateAssessment' className='add-only'/></td>
    </tr>
</table>
<table>
    <tr>
        <td className='w-375'><span className='eleHeader'>Information Provided</span></td>
        <td className='w-375'><span className='eleHeader'>Intitials Confirmation Receipt of Information</span></td>
    </tr>
    <tr>
        <td className='w-375'>Client Orientation to Services</td>
        <td className='w-375'>
            <input type='text' id='txtOrientation' name='txtOrientation' className='add-only'/></td>
    </tr>
    <tr>
        <td className='w-375'>Client Orientaion Handbook</td>
        <td className='w-375'>
            <input type='text' id='txtOrientation1' name='txtOrientation1' className='add-only'/></td>
    </tr>
    <tr>
        <td className='w-375'>Admisssion/Exclusion Criteria</td>
        <td className='w-375'>
            <input type='text' id='txtOrientation2' name='txtOrientation2' className='add-only'/></td>
    </tr>
    <tr>
        <td className='w-375'>Discharge/Termination Criteria</td>
        <td className='w-375'>
            <input type='text' id='txtOrientation3' name='txtOrientation3' className='add-only'/></td>
    </tr>
    <tr>
        <td className='w-375'>Mandatory Abuse/Neglect Reporting</td>
        <td className='w-375'>
            <input type='text' id='txtOrientation4' name='txtOrientation4' className='add-only'/></td>
    </tr>
    <tr>
        <td className='w-375'>Client Rights</td>
        <td className='w-375'>
            <input type='text' id='txtOrientation5' name='txtOrientation5' className='add-only' /></td>
    </tr>
    <tr>
        <td className='w-375'>Rights to Confidentiality</td>
        <td className='w-375'>
            <input type='text' id='txtOrientation6' name='txtOrientation6' className='add-only' /></td>
    </tr>
    <tr>
        <td className='w-375'>Client Choice for Behavioral Health Treatment</td>
        <td className='w-375'>
            <input type='text' id='txtOrientation7' name='txtOrientation7' className='add-only' /></td>
    </tr>
    <tr>
        <td className='w-375'>Client Crisis/Emergency Information</td>
        <td className='w-375'>
            <input type='text' id='txtOrientation8' name='txtOrientation8' className='add-only' /></td>
    </tr>
    <tr>
        <td className='w-375'>Florida Advance Directives</td>
        <td className='w-375'>
            <input type='text' id='txtOrientation9' name='txtOrientation9' className='add-only' /></td>
    </tr>
</table>
<p className='w-750'>
    Right Path Behavioral Health Services
    1725 Oakhurst Avenue, Jacksonville, FL 32208
    Phone: 904-765-0665 Fax: 904-765-0664
</p>
<table>
    <tr>
        <td className='w-375'><span className='eleHeader'>Client Name:</span></td>
        <td className='w-375'><span className='eleHeader'>CID#:</span></td>

    </tr>
    <tr>
        <td className='w-375'>
            <input type='text' id='txtClientName1' name='txtClientName1' className='add-only'/></td>
        <td className='w-375'>
            <input type='text' id='txtDateAssessment1' name='txtDateAssessment1' className='add-only'/></td>

    </tr>
</table>


                
            </div>
        </form>

    )
}











